<template>
    <div>
        <common-modal v-if="isOpen" height="small" @close="$emit('close')">
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('modals.make_direct_referal_modal.inivte_billing.modal_title')"
                    :content="$t('modals.make_direct_referal_modal.inivte_billing.modal_content')"
                    :isCenter="true"
                    contentSpacing="medium"
                    contentColor="secondary"
                ></common-page-header>
                <common-buttons class="referral-tracking__show-more">
                    <common-button
                        :label="$t('pages.billing.billing.trial.go_billing')"
                        type="primary"
                        size="large"
                        @click="goToBilling"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-modal>
    </div>
</template>
<script>
    export default {
        props: {
            isOpen: { type: Boolean, required: true },
        },
        methods: {
            goToBilling() {
                this.$router.push({ name: 'practice.billing' })
            },
        },
    }
</script>
